import React, { useState } from 'react'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { InfiniteData } from 'react-query'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useNavigate, useParams } from 'react-router'
import { IoSearch, IoClose } from 'react-icons/io5'
import { FiUserPlus } from 'react-icons/fi'
interface IFundUsersProps {
    data: InfiniteData<IGetMoneyPoolUsers>
    isLoading: boolean
    onWatchEnd: () => void
    shareValueAmount: number
    isManager: boolean
    setIsOpenPayToOtherModal: React.Dispatch<React.SetStateAction<boolean>>
    setSelectUser: React.Dispatch<
        React.SetStateAction<IMoneyPoolResults | undefined>
    >
    setSearchUser: React.Dispatch<React.SetStateAction<string>>
    search: string
    setSearch: React.Dispatch<React.SetStateAction<string>>
    refetch: () => void
}
export default function Users({
    data,
    isLoading,
    onWatchEnd,
    shareValueAmount,
    isManager,
    setIsOpenPayToOtherModal,
    setSelectUser,
    setSearchUser,
    search,
    setSearch,
    refetch,
}: IFundUsersProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    const [searchMode, setSearchMode] = useState<boolean>(false)

    const closeSearch = () => {
        setSearch('')
        setSearchUser('')
        setSearchMode(false)
    }

    return (
        <div className="bg-white min-h-screen">
            {/* search + add-member row (Android list_item_mp_search_member, 55dp) */}
            <div className="h-[55px] mt-[5px] mb-2 flex items-center">
                {searchMode ? (
                    <>
                        <input
                            type="text"
                            autoFocus
                            className="flex-1 ml-2 mr-4 h-[55px] px-[3px] text-[15px] text-black outline-0 bg-transparent border-b border-stroke placeholder:text-text-muted"
                            placeholder="جستجوی نام و شماره تلفن"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') setSearchUser(search)
                            }}
                        />
                        <button
                            onClick={closeSearch}
                            className="w-[45px] h-[45px] mr-4 ml-[3px] flex items-center justify-center rounded-[4px] bg-[#EFEFEF] shrink-0"
                        >
                            {/* add_member_bg: #EFEFEF outer + 1dp white inset
                                = thin gray ring / white center */}
                            <span className="w-[43px] h-[43px] flex items-center justify-center rounded-[4px] bg-white">
                                <IoClose className="w-5 h-5 text-black" />
                            </span>
                        </button>
                    </>
                ) : (
                    <>
                        <button
                            onClick={() => setSearchMode(true)}
                            className="w-8 h-8 ml-1.5 mr-4 p-[5px] flex items-center justify-center shrink-0"
                        >
                            <IoSearch className="w-full h-full text-green-1" />
                        </button>
                        {isManager && (
                            <div
                                className="flex-1 h-[55px] ml-4 flex items-center justify-end gap-2 cursor-pointer active:opacity-80"
                                onClick={() =>
                                    navigate(`/fund/add-new-user/${id}`)
                                }
                            >
                                <p className="text-[15px] text-black">
                                    افزودن عضو جدید
                                </p>
                                <FiUserPlus className="w-5 h-5 text-green-1 mr-[5px]" />
                            </div>
                        )}
                    </>
                )}
            </div>

            <InfiniteScroll
                next={onWatchEnd}
                hasMore={
                    data
                        ? data?.pages[data.pages.length - 1].next
                            ? true
                            : false
                        : false
                }
                dataLength={
                    data
                        ? data.pages.flatMap((x) => x.results).length
                            ? data.pages.flatMap((x) => x.results).length
                            : 0
                        : 0
                }
                loader={<DotsLoading />}
            >
                <div>
                    {data && !isLoading ? (
                        <>
                            {data.pages
                                .flatMap((x) => x.results)
                                .map((item) => (
                                    <div key={item.id}>
                                        {item.is_active && (
                                            <Item
                                                isManager={isManager}
                                                item={item}
                                                shareValueAmount={
                                                    shareValueAmount
                                                }
                                                setSelectUser={setSelectUser}
                                                setIsOpenPayToOtherModal={
                                                    setIsOpenPayToOtherModal
                                                }
                                                refetch={refetch}
                                            />
                                        )}
                                    </div>
                                ))}
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </InfiniteScroll>
        </div>
    )
}
